import {mount} from 'svelte';

import InitializeLayout from '@js/layout';

import PlanIndex from '@js/components/plan/PlanIndex.svelte';

InitializeLayout();

const target = document.getElementById('plan-component');

const allFilters = JSON.parse(target.getAttribute('data-all-filters') || {});

mount(PlanIndex, {
    target,
    props: {
        allFilters: allFilters
    }
});
